<google-chart #barchart [title]="title" [type]="chartType" [data]="myData" [options]="options" [columns]="columnNames"
    [style]="cStyle" (select)="OnSelect($event)"></google-chart>